import { Fragment } from "react"
import { Box, SxProps } from "@mui/material"
import { ImdfFeature } from "providers/venue/types"
import { VerticalDirectoryOccupantCard } from "components/domains/directory/VerticalDirectoryOccupantCard"

interface IDirectoryListLayoutProps {
  pages: Array<{ data: ImdfFeature[] }>
  gridItemSx?: SxProps
}

export const DirectoryListLayout = ({
  pages,
  gridItemSx,
}: IDirectoryListLayoutProps) => {
  return (
    <>
      {pages.map((page, pageNum) => (
        <Fragment key={pageNum}>
          {page.data.map((occupant) => {
            const isAd = occupant?.properties?.isAd
            const occupantId = String(occupant?.id)
            const isNewShop = occupant?.properties?.isNewShop
            const isComingSoon = occupant?.properties?.isComingSoon

            return (
              <Box
                id={occupantId}
                data-testid={occupantId}
                sx={gridItemSx}
                key={`${isAd ? "ad-" : "directory-item-"}${occupantId}`}
              >
                <VerticalDirectoryOccupantCard
                  data={occupant}
                  isNewShop={isNewShop}
                  isComingSoon={isComingSoon}
                />
              </Box>
            )
          })}
        </Fragment>
      ))}
    </>
  )
}
